<h1 mat-dialog-title>ASSOCIATE THERAPISTS</h1>
<mat-dialog-content class="pt-3">

    <p>Select the therapists that are attending this event</p>

    @if (this.allTherapists && this.therapistsAtEvent && therapistsNotAtEvent){

    @for (therapist of therapistsNotAtEvent; track therapist.therapistID){

    <div (click)="toggleTherapistAtEvent(therapist.therapistID)" [class.disabled-card]="isReloading"
        [class.selected-card]="eventTherapistIds.has(therapist.therapistID)" class="card p-3 rounded-0 my-2">
        <div class="row">
            <div class="col-auto">
                <img class="img-fluid rounded-pill" style="width: 30px; height: 30px;"
                     src="{{getThumbURL(therapist.profileLargeURL)}}">
            </div>
            <div class="col d-flex align-items-center">
                <p class="mb-0">{{therapist.firstName}} {{therapist.lastName}}</p>
            </div>
            <div class="col-auto d-flex align-items-center text-primary">
                <mat-icon [class.d-none]="!eventTherapistIds.has(therapist.therapistID)">check_circle</mat-icon>
            </div>
        </div>
    </div>


    }
    }

    <button class="d-block d-lg-inline-block w-100 mt-3" mat-dialog-close mat-flat-button color="primary">CLOSE</button>




</mat-dialog-content>
